// Imports for external libraries go here.
import { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { LogoBlockProps } from './LogoBlock.types';
import { StyledLogoBlock, StyledLogoBlockContainer } from './LogoBlock.styles';
import { EditableComponent } from '@adobe/aem-react-editable-components';
/* eslint-disable @nx/enforce-module-boundaries */
import { VariableColumnContainer } from '@marriott/mi-common-static-components';
import { useDCADynamicModelAlloy } from '../../modules/helpers';

// Use named rather than default exports.
export const LogoBlock: FC<LogoBlockProps> = (props: LogoBlockProps) => {
  /**
   * Fetching the target response
   */
  const mboxParam = props?.model?.mboxParameter;

  /***
   * Makes the call to target if mboxParam is authored
   */
  const targetResponse = useDCADynamicModelAlloy(mboxParam);
  const targetData = targetResponse?.targetData;

  /**
   * Replacing the AEM model data with target data if target Response is present
   */
  const model = targetData ? targetData : props?.model;

  const finalPropsData = {
    ...model,
    isAuthorMode: model?.isAuthor,
    allowedComponents: [
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/iconblock',
        title: 'Icon Block',
      },
      {
        path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/container',
        title: 'Container',
      },
    ],
  };

  return (
    <StyledLogoBlock data-testid="luxury-LogoBlock" data-component-name="m-luxury-LogoBlock">
      <VariableColumnContainer model={finalPropsData} />
    </StyledLogoBlock>
  );
};

export const LogoBlockConfig = {
  emptyLabel: 'LogoBlock',
  isEmpty: () => true,
  resourceType: `mi-aem-common-spa/components/content/variablecolumncontainer`,
};

export const LogoBlockEditable = (props: LogoBlockProps) => {
  return (
    <StyledLogoBlockContainer
      data-testid="luxury-LogoBlock"
      data-component-name="m-luxury-LogoBlock"
      className="m-container-fullbleed"
    >
      <EditableComponent config={LogoBlockConfig} {...props.model}>
        <LogoBlock {...props} />
      </EditableComponent>
    </StyledLogoBlockContainer>
  );
};
